import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { MDShape } from '../../../MDA/Designer/BaseShape/MDShape';

/** 复制的内容 */
export class CopyContent {
  private _curDesignId: string;
  private _curShape: MDShape;
  private _curElement: BaseElement;

  /**
   * 构造函数，图形与当前元素必须存在，且与其容器脱离关系
   * @param curShape 当前要复制的图形
   * @param curElement 当前要复制的元素，可能是图形对应元素的子
   */
  constructor (curShape: MDShape, curElement: BaseElement) {
    this._curShape = curShape;
    this._curElement = curElement;
    this._curDesignId = curElement.designId;
  }

  /** 获取：当前复制的元数据的设计期ID */
  get curDesignId(): string {
    return this._curDesignId;
  }

  /** 获取：当前复制的图形或当前复制行的容器图形 */
  get curShape(): MDShape {
    return this._curShape;
  }

  /** 获取当前复制的元数据 */
  get curElement(): BaseElement {
    return this._curElement;
  }
}
